class ReviewsController extends HTMLElement {
  constructor() {
    super();

    this.buttonTabs = null;
    this.tabPanels = null;
    this.currentTabId = null;
    this.prevTabId = null;
    this.tabPanelPrefix = 'tab-panel-';
    this.tabBtnPrefix = 'tab-button-';
  }

  // You already know what this one is doing
  connectedCallback() {
    this.buttonTabs = this.querySelectorAll('.reviews-tab-button'); // store the list of elements to cache them here in class so no need to refetch everytime
    this.tabPanels = this.querySelectorAll('.review-tab-panel'); // store the list of elements to cache them here in class so no need to refetch everytime

    this.initTabEvents();
  }

  initTabEvents() {
    this.buttonTabs.forEach((thisBtn) => {
      const blockId = thisBtn.getAttribute('data-block-id');
      const buttonLabelElement = thisBtn.querySelectorAll('.button-label');

      // Method to set the button text inside the button label
      this.setButtonText(blockId, buttonLabelElement);

      // There is an option in the section to show the initial panel to open
      if (thisBtn.getAttribute('aria-selected') === 'true') {
        this.currentTabId = blockId;

        this.showTab();
      }

      thisBtn.addEventListener('click', () => this.switchTab(thisBtn, blockId));
    });
  }

  //Removing Events for Tabs to prevent memory leak. Check disconnectedCallback
  removeTabEvents() {
    this.buttonTabs.forEach((el) => {
      el.removeEventListener('click', this.switchTab);
    });
  }

  // This method sets the current and previous tabs so we dont need to
  // use loop just to show which active or not active panel to show
  switchTab(thisBtn, blockId) {
    this.prevTabId = blockId !== this.currentTabId && this.currentTabId;
    this.currentTabId = blockId;
    thisBtn.setAttribute('aria-selected', 'true');
    thisBtn.setAttribute('tabindex', '0');
    this.showTab();

    const prevTab = document?.getElementById(
      `${this.tabPanelPrefix}${this.prevTabId}`
    );

    const prevBtn = document?.getElementById(
      `${this.tabBtnPrefix}${this.prevTabId}`
    );

    prevTab?.setAttribute('aria-hidden', true);
    prevBtn?.setAttribute('aria-selected', 'false');
    prevBtn?.setAttribute('tabindex', '-1');
  }

  // Show the Current Tab and we use the aria hidden so we can manipulate via css instead of class
  // If need to add a custom class in the future, just add below
  showTab() {
    const currentTab = document?.getElementById(
      `${this.tabPanelPrefix}${this.currentTabId}`
    );

    currentTab?.setAttribute('aria-hidden', false);

    const okendoContainerId = currentTab.getAttribute(
      'data-okendo-container-id'
    );

    this.initOkendoGroup(okendoContainerId);
  }

  // Setting the Button Text as we cant get the block title if we use the Theme block
  // We will get the title from the panel attached
  setButtonText(id, buttonLabelElement) {
    const currentTab = document?.getElementById(`${this.tabPanelPrefix}${id}`);
    const currentTextTitle = currentTab.getAttribute('data-tab-title');

    buttonLabelElement?.forEach((el) => {
      el.innerHTML = currentTextTitle;
    });
  }

  initOkendoGroup(containerId) {
    const container = document.querySelector(`#${containerId}`);
    const isOkendoWidgetInit = container.getAttribute('data-okendo-init');

    if (isOkendoWidgetInit === 'true') {
      console.info('Okendo Widget Already initialzed');

      return null;
    }

    if (
      !window.okeWidgetApi &&
      typeof window.okeWidgetApi?.initWidget !== 'function'
    ) {
      console.warn('Okendo Widget API Missing');

      return null;
    }

    if (
      window.okeWidgetApi &&
      typeof window.okeWidgetApi.initWidget === 'function'
    ) {
      container.setAttribute('data-okendo-init', 'true');
      window.okeWidgetApi.initWidget(container, true);
      console.info('Okendo Widget API Done Initializing');
    }
  }

  disconnectedCallback() {
    this.removeTabEvents();
  }
}

customElements.define('review-tabs-controller', ReviewsController);
